import styled from '@emotion/styled';
import { StyledProps, Theme } from './Container.types';
import facepaint from 'facepaint';
import { space } from 'styled-system';

const media = (theme: Theme): string[] => theme.screenSizes.map((size) => `@media(min-width: ${size}px)`);
const mediaWithXs = (theme: Theme): string[] => [
  `@media(max-width: ${theme.container.width.screenSizes[0]}px)`,
  ...media(theme),
];
const maxWidths = (theme: Theme): string[] => theme.container.width.screenSizes.map((width) => `${width}px`);

const margins = (theme: Theme): string[] => theme.container.margin.screenSizes.map((width) => `${width}px`);

export default styled.div<StyledProps, Theme>`
  ${(props) =>
    facepaint(mediaWithXs(props.theme))({
      margin: '0 auto',
      maxWidth: [props.theme.container.width.default, ...maxWidths(props.theme)],
      display: 'grid',
    })}

  ${space}
`;
